import type { MouseEvent, ReactNode } from "react";
import { IconFile, IconX } from "@tabler/icons-react";
import Text from "../../UI/Text";
import IconButton from "../../UI/IconButton";
// @ts-expect-error pure js
import { classnames } from "../../../utils";
import styles from "./BulkSelectionCard.module.css";

interface BulkSelectionCardProps {
  fileName: string;
  tenantName: string;
  isActive: boolean;
  isIneligible: boolean;
  ineligibleReason?: string;
  onSelect: () => void;
  onRemove?: () => void;
  children?: ReactNode;
}

export default function BulkSelectionCard({
  fileName,
  tenantName,
  isActive,
  isIneligible,
  ineligibleReason,
  onSelect,
  onRemove,
  children,
}: BulkSelectionCardProps) {
  return (
    <div
      className={classnames(
        styles.card,
        isIneligible && styles.cardError,
        isActive && styles.cardActive,
      )}
      onClick={onSelect}
    >
      <div className={styles.cardHeader}>
        <IconFile size={20} />
        <Text as="span" weight="bold" className={styles.cardTitle}>
          {fileName}
        </Text>
        {onRemove && (
          <IconButton
            icon={IconX}
            variant="plain"
            size="sm"
            label="Retirer de la sélection"
            onClick={(e: MouseEvent) => {
              e.stopPropagation();
              onRemove();
            }}
          />
        )}
      </div>
      <div className={styles.cardTexts}>
        <Text weight="bold">{tenantName}</Text>
        {isIneligible ? (
          <Text variant="deci">{ineligibleReason}</Text>
        ) : (
          children
        )}
      </div>
    </div>
  );
}

interface BulkSelectionCardRowProps {
  label: ReactNode;
  children: ReactNode;
}

export function BulkSelectionCardRow({
  label,
  children,
}: BulkSelectionCardRowProps) {
  return (
    <Text as="div" color="muted" className={styles.cardRow}>
      <Text as="span" variant="deci">
        {label}
      </Text>
      <Text as="span" variant="deci">
        {children}
      </Text>
    </Text>
  );
}
